<template>
  <div class="shop-item" @click="onDetail(product.id)">
    <div class="shop-item-l">
      <img :src="product.image" />
    </div>
    <div class="shop-item-r">
      <div class="shop-item-title">
        {{ product.title }}
      </div>
      <div class="shop-item-config">详细配置：{{ product.configdesc }}</div>
      <div class="shop-item-price-discount">
        ￥{{ product.price }}
      </div>
      <div class="shop-item-info">
        <div class="shop-tab">
          ID：<span>{{ product.id }}</span>
        </div>
        <div class="shop-tab">
          <img class="product-icon" src="@/assets/images/icons/click.png"/>
          <span class="product-text">{{ product.clicknum }}</span>
        </div>
        <div class="shop-tab">
          <img class="product-icon" src="@/assets/images/icons/time.png"/>
          <span class="product-text">{{ oformatDate(product.updtime) }}</span>
        </div>
      </div>
    </div>
    <div class="clear"></div>
  </div>
</template>

<script>
import {formatDate} from '@/utils/tools';
export default {
  name: "ProductComponent",
  props: {
     product:{
       types: Object,
       required: true
     }
  },
  methods: {
    oformatDate (str) {
      return formatDate(str)
    },
    onDetail (id) {
        this.$router.push({name: 'detail', query:{ id: id}});
    },
  }
};
</script>
<style>
</style>
<style lang="scss" scoped>
.shop-list-box .shop-list .shop-list-show  .shop-item  {
  .shop-item-l {
    width: 120px;
    height: 120px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 120px;
    }
  }
  .shop-item-r {
    .shop-item-config {
      color: #999999;
      margin-top: 3px;
      font-size: 14px;
      line-height: 18px;
      font-weight: normal;
      height: 36px;
      overflow: hidden;
      text-align: justify;
    }
    .shop-item-title {
      font-family: "黑体";
      font-size: 16px;
      height: 40px;
      line-height: 20px;
      overflow: hidden;
      text-align: justify;
    }
    .shop-item-info {
      color: #999999;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    .shop-item-price-discount {
      font-size: 16px;
    }
  }
}
.shop-tab {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 15px;
  .product-icon {
    width: 14px;
    height: 14px;
  }
  .product-text {
    margin-left: 5px;
  }
}
</style>
